import { apiMaybe } from '../../services/apiClient';

export function buildReviewSearchQuery({ q, limit } = {}) {
  const params = new URLSearchParams();
  if (q != null && String(q).trim() !== '') params.set('q', String(q).trim());
  if (limit) {
    params.set('page', '1');
    params.set('pageSize', String(limit));
  }
  return params.toString();
}

/**
 * Quick-find over document reviews (used by ⌘K). Reuses the list endpoint's
 * `q` filter — title/filename, submitter name/email. The backend already
 * scopes requesters to their own reviews (reviewers see all), so callers
 * don't need any extra gating.
 */
export function searchReviews(params = {}) {
  const query = buildReviewSearchQuery(params);
  return apiMaybe(`/reviews${query ? `?${query}` : ''}`);
}
